module.exports = __webpack_public_path__ + "static/media/7_5.75961003.png";